import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import Header from "./components/Header";
import PurposeSection from "./components/PurposeSection";
import TeasersSection from "./components/TeasersSection";

const App = () => {
  return (
    <div>
      <Header />
      <PurposeSection />
      <TeasersSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default App;
